import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { NgGameDefinition } from "../model/ng-game-definition";

interface NgGameList {
    categories: any; // usesless
    games: {
        instant: NgGameDefinition[];
    };
}

let gameList: NgGameDefinition[] = null;
let gameListReadyPromiseResolve: (value: NgGameDefinition[]) => void = null;

const loadGameList = () => {
    return new Promise((res) => {
        if (gameList) {
            res(gameList);
        } else {
            gameListReadyPromiseResolve = res;
            ng_fw.updateGamesList();
        }
    });
};

/**
 * Called by NG on game list ready
 */
const gameListReady = (list: NgGameList) => {
    gameList = list?.games?.instant || null;
    // NG sometimes fires game list updated, without our loadGameList being called
    // so in that case, promise is null
    if (gameListReadyPromiseResolve) {
        gameListReadyPromiseResolve(gameList);
    }
};

/**
 * Finds game by id in NG game list
 */
const getGameFromNgList = (id: number) => gameList?.find((game) => game.id == id);

/**
 * Fetches game definition from NG by id
 */
const fetchNgGameDefinition = async (id: number): Promise<NgGameDefinition> => {
    await loadGameList();
    return getGameFromNgList(id);
};

/**
 * Gets game definition from already loaded NG game list. If game list is not loaded yet, returns null.
 */
const getNgGameDefinition = (id: number): NgGameDefinition => {
    const game = getGameFromNgList(id);

    return game;
};

const initializeGameList = async () => {
    await ngFrameworkLoaded();
    ng_hs.onGamesListUpdated(gameListReady);
    ng_fw.updateGamesList();
};

export const useNgCasinoGameList = () => ({
    initializeGameList,
    fetchNgGameDefinition,
    getNgGameDefinition,
});
